// @subframe/sync-disable

"use client";
/*
 * Documentation:
 * Bold navbar mobile — https://app.subframe.com/4127f7e60777/library?component=Bold+navbar+mobile_44129e0d-2104-4c54-a4f8-23a5d8845df2
 * Link Button — https://app.subframe.com/4127f7e60777/library?component=Link+Button_a4ee726a-774c-4091-8c49-55b659356024
 * Button — https://app.subframe.com/4127f7e60777/library?component=Button_3b777358-b86b-40af-9327-891efc6826fe
 */

import React from "react";
import * as SubframeCore from "@subframe/core";
import { LinkButton } from "./LinkButton";
import { Button } from "./Button";

interface NavItemProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  selected?: boolean;
  className?: string;
}

const NavItem = React.forwardRef<HTMLElement, NavItemProps>(function NavItem(
  { children, selected = false, className, ...otherProps }: NavItemProps,
  ref
) {
  return (
    <div
      className={SubframeCore.twClassNames(
        "group/437b1098 flex h-8 cursor-pointer flex-col items-center justify-center gap-4 rounded-full px-4",
        { "bg-brand-200": selected },
        className
      )}
      ref={ref as any}
      {...otherProps}
    >
      {children ? (
        <span className="font-['Montserrat'] text-[15px] font-[600] leading-[20px] text-brand-900">
          {children}
        </span>
      ) : null}
    </div>
  );
});

interface BoldNavbarMobileRootProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  aboutClicked?: () => void;
  onLoginClicked?: () => void;
  onSignupClicked?: () => void;
}

const BoldNavbarMobileRoot = React.forwardRef<
  HTMLElement,
  BoldNavbarMobileRootProps
>(function BoldNavbarMobileRoot(
  { className, aboutClicked, onLoginClicked, onSignupClicked, ...otherProps }: BoldNavbarMobileRootProps,
  ref
) {
  return (
    <div
      className={SubframeCore.twClassNames(
        "flex w-full max-w-[1280px] flex-wrap items-center justify-between",
        className
      )}
      ref={ref as any}
      {...otherProps}
    >
      <div className="flex h-12 flex-col items-start justify-center gap-2 px-4">
        <img
          className="h-10 flex-none object-cover"
          src="https://i.imgur.com/Q79snHK.png"
        />
      </div>
      <div className="flex items-center gap-2 px-2">
        <LinkButton onClick={aboutClicked}>About</LinkButton>
        <Button variant="brand-tertiary" onClick={onLoginClicked}>
          Log in
        </Button>
        <Button onClick={onSignupClicked}>Sign up</Button>
      </div>
    </div>
  );
});

export const BoldNavbarMobile = Object.assign(BoldNavbarMobileRoot, {
  NavItem,
});
